import AttachRegular from 'mini-fluent-svg-icons/lib/icons/AttachRegular';
import FlagRegular from 'mini-fluent-svg-icons/lib/icons/FlagRegular';
import MailUnreadRegular from 'mini-fluent-svg-icons/lib/icons/MailUnreadRegular';
import MentionRegular from 'mini-fluent-svg-icons/lib/icons/MentionRegular';
import PersonMailRegular from 'mini-fluent-svg-icons/lib/icons/PersonMailRegular';
import PinRegular from 'mini-fluent-svg-icons/lib/icons/PinRegular';
import ViewFilter from 'owa-service/lib/contract/ViewFilter';
import { getPropsForViewFilter } from './getPropsForViewFilter';
import { lazySelectFilter } from 'mini-mail-filter-actions';
import { lazyShowSelectableListInBottomSheet } from 'mini-bottomsheet-selectablelist';
import { MailListFilterMenuItem } from '../schema/MailListFilterMenuItem';
import { SelectableListItems } from 'mini-selectable-list';
import { signalWorkflowEvent } from 'mini-workflow-manager';
import {
    FILTER_BUTTON_CLICKED,
    FILTER_OVERLAY_CLICKED,
} from 'mini-mail-workflow-tracking/lib/constants/ListViewWorkflowConstants';

export const onMailListFilterClickCallback = (
    activeViewFilter: ViewFilter,
    ref?: React.RefObject<HTMLDivElement>
) => {
    if (activeViewFilter !== 'All') {
        // Clear the existing filter if any, and clearing a filter means a wildcard filter which is All
        return () => lazySelectFilter.importAndExecute('All');
    }

    const mailListFilterMenuItems: MailListFilterMenuItem[] = [
        {
            icon: MailUnreadRegular,
            key: 'Unread',
        },
        {
            icon: PersonMailRegular,
            key: 'ToOrCcMe',
        },
        {
            icon: FlagRegular,
            key: 'Flagged',
        },
        {
            icon: PinRegular,
            key: 'Pinned',
        },
        {
            icon: AttachRegular,
            key: 'HasFile',
        },
        {
            icon: MentionRegular,
            key: 'Mentioned',
        },
    ] as MailListFilterMenuItem[];

    const bottomSheetItems: SelectableListItems[] = mailListFilterMenuItems.map(
        (filterItem: MailListFilterMenuItem): SelectableListItems => ({
            ...filterItem,
            name: getPropsForViewFilter(filterItem.key).label,
            key: filterItem.key,
        })
    );

    const onSelect = selectedItems => {
        lazySelectFilter.importAndExecute(selectedItems[0]);
    };

    return () => {
        // Log perf datapoint to track filter workflow
        signalWorkflowEvent(FILTER_BUTTON_CLICKED, { isUIAction: true }, { isCore: true });

        return lazyShowSelectableListInBottomSheet.importAndExecute(
            { items: bottomSheetItems, onSelect: onSelect, showSeparator: true },
            {
                elementToFocusOnClose: ref,
                id: 'MailListFilterOptions',
                onOverlayClick: () => {
                    signalWorkflowEvent(
                        FILTER_OVERLAY_CLICKED,
                        { isUIAction: true },
                        { isCore: true }
                    );
                },
            }
        );
    };
};
